import { ActionContext, Module } from "vuex";

import { Command } from "@/commands";
import { RootState } from "@/store/root";

export interface HistoryState {
  undo: Command[];
  redo: Command[];
}

export const history: Module<HistoryState, RootState> = {
  state: {
    undo: [],
    redo: []
  },
  namespaced: true,
  mutations: {
    UNDO(state: HistoryState) {
      const command = state.undo.pop();
      if (command) state.redo.push(command);
    },
    REDO(state: HistoryState) {
      const command = state.redo.pop();
      if (command) state.undo.push(command);
    },
    PUSH(state: HistoryState, command: Command) {
      state.undo.push(command);
      state.redo = [];
    },
    CLEAR(state: HistoryState) {
      state.undo = [];
      state.redo = [];
    }
  },
  actions: {
    undo(context: ActionContext<HistoryState, RootState>) {
      if (context.getters.canUndo) {
        const command = context.state.undo[context.state.undo.length - 1];

        command
          .undo()
          .forEach(([type, payload]) =>
            context.commit(type, payload, { root: true })
          );

        context.commit("UNDO");
      }
    },
    redo(context: ActionContext<HistoryState, RootState>) {
      if (context.getters.canRedo) {
        const command = context.state.redo[context.state.redo.length - 1];

        command
          .execute()
          .forEach(([type, payload]) =>
            context.commit(type, payload, { root: true })
          );

        context.commit("REDO");
      }
    },
    push(context: ActionContext<HistoryState, RootState>, command: Command) {
      context.commit("PUSH", command);
    },
    clear(context: ActionContext<HistoryState, RootState>) {
      context.commit("CLEAR");
    }
  },
  getters: {
    canUndo(state: HistoryState) {
      return state.undo && state.undo.length > 0;
    },
    canRedo(state: HistoryState) {
      return state.redo && state.redo.length > 0;
    }
  }
};
